"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LinearProgress = _interopRequireDefault(require("@eig-builder/core-ui/LinearProgress"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _text = _interopRequireDefault(require("./components/text"));

var _modalContext = _interopRequireDefault(require("../modal-context"));

var _moduleNotificationBarWithContext = require("@eig-builder/module-notification-bar-with-context");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute !important;\n  width: 100%;\n  left: 0;\n  top: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 1 1 auto;\n  overflow-y: auto;\n  position: relative;\n  height: ", ";\n  margin-top: ", ";\n  padding: ", ";\n\n  &.modal-content-xs {\n    padding: ", ";\n  }\n\n  &.modal-content-small {\n    padding: ", ";\n  }\n\n  &.modal-content-medium {\n    padding: ", ";\n  }\n\n  &.modal-content-large {\n    padding: ", ";\n  }\n\n  &.processing {\n    &:after {\n      content: '';\n      width: 100%;\n      height: calc(100% - 4px);\n      position: absolute;\n      top: 4px;\n      left: 0;\n\n      background-color: ", ";\n      opacity: 0.6;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalContentBase = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.height;
}, function (props) {
  return "".concat(props.marginTop, "px");
}, function (props) {
  return props.padding || props.theme.spacing(4, 0);
}, function (props) {
  return "".concat(props.theme.spacing(2), "px");
}, function (props) {
  return "".concat(props.theme.spacing(6), "px");
}, function (props) {
  return props.theme.spacing(8, 10);
}, function (props) {
  return props.theme.spacing(10, 16);
}, function (props) {
  return props.theme.palette.white.main;
});

var StyledLinearProgress = (0, _styledComponents["default"])(_LinearProgress["default"])(_templateObject2());

var ModalContent = function ModalContent(props) {
  var _useContext = (0, _react.useContext)(_modalContext["default"]),
      bodyScroll = _useContext.bodyScroll,
      headerRef = _useContext.headerRef,
      tabsRef = _useContext.tabsRef,
      processing = _useContext.processing;

  var _useState = (0, _react.useState)(bodyScroll ? 0 : 64),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      marginTop = _useState2[0],
      setMarginTop = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!bodyScroll) {
      if (props.marginTop) {
        setMarginTop(props.marginTop);
      } else if (headerRef.current) {
        var headerHeight = headerRef.current.clientHeight;

        if (!tabsRef.current && headerHeight !== marginTop) {
          setMarginTop(headerHeight);
        } else if (tabsRef.current && tabsRef.current.querySelector('.modal-tabs').clientHeight + headerHeight !== marginTop) {
          // Currently, there is no other way of accessing this, because of how Clean Tabs was build..
          setMarginTop(tabsRef.current.querySelector('.modal-tabs').clientHeight + headerHeight);
        }
      }
    }
  }, [headerRef.current, tabsRef.current, props.marginTop]);
  return _react["default"].createElement(ModalContentBase, (0, _extends2["default"])({}, (0, _omit["default"])(props, 'children', 'hasNotificationBarContainer', 'contentSpacing'), {
    className: "modal-content-".concat(props.contentSpacing, " ").concat(processing ? 'processing' : ''),
    marginTop: marginTop
  }), processing && _react["default"].createElement(StyledLinearProgress, null), props.hasNotificationBarContainer && _react["default"].createElement(_moduleNotificationBarWithContext.NotificationBarContainer, {
    targetKey: "wizard"
  }), props.children);
}; // Compound.


ModalContent.Text = _text["default"]; // Define proptypes.

ModalContent.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  contentSpacing: _propTypes["default"].oneOf(['none', 'xs', 'small', 'medium', 'large']),
  padding: _propTypes["default"].string,
  marginTop: _propTypes["default"].number,
  hasNotificationBarContainer: _propTypes["default"].bool
};
ModalContent.defaultProps = {
  height: 'auto',
  contentSpacing: 'small',
  padding: null,
  hasNotificationBarContainer: true
};
var _default = ModalContent;
exports["default"] = _default;